// BHP-1070: concrete CustomerGateway over the Backend2.0 HTTP client.
import { httpClient } from '../../../shared/http/httpClient';
import { normalizeItem } from '../../../shared/api/hydra';
import type { Customer } from '../domain/customer';
import type { CustomerGateway } from '../domain/customerGateway';

const CUSTOMERS_RESOURCE = '/customers';

export const customerApiAdapter: CustomerGateway = {
  createCustomer: async (input) => {
    const raw = await httpClient.post<Record<string, unknown>>(
      CUSTOMERS_RESOURCE,
      input
    );
    return toCustomer(normalizeItem<Record<string, unknown>>(raw));
  }
};

function toCustomer(raw: Record<string, unknown>): Customer {
  return {
    uuid: String(raw.uuid ?? ''),
    type: String(raw.type ?? ''),
    companyName: typeof raw.companyName === 'string' ? raw.companyName : null,
    email: String(raw.email ?? ''),
    phoneNumber: String(raw.phoneNumber ?? ''),
    administrationFullName: String(raw.administrationFullName ?? '')
  };
}
